import React from 'react';
import {Flex} from "antd";
import {State, StateDate} from "../../components/brief/Stages";
import {t} from "i18next";

interface StateBlock {
  state: State;
  dateState: StateDate;
  text: string;
}

interface Color {
  background?: string,
  color?: string,
}

const colors: Record<string, Color> = {
  [State.InWork]: {background: '#FFE49D'},
  [State.Completed]: {background: '#DBF4E3'},
  [State.NotStarted]: {background: '#FFFFFF', color: '#D5DCDF'},
  [StateDate.Overdue]: {color: '#DE1E04'},
  [StateDate.Advance]: {color: '#0075FF'},
  [StateDate.Plan]: {color: '#384146'},
}

export default function Legend() {
  const blocks: StateBlock[] = [
    {state: State.InWork, dateState: StateDate.Plan, text: t('gant.inWork')},
    {state: State.InWork, dateState: StateDate.Advance, text: t('gant.inWorkAdvance')},
    {state: State.InWork, dateState: StateDate.Overdue, text: t('gant.inWorkOverdue')},
    {state: State.Completed, dateState: StateDate.Plan, text: t('gant.completedByPlan')},
    {state: State.Completed, dateState: StateDate.Advance, text: t('gant.completedAdvance')},
    {state: State.Completed, dateState: StateDate.Overdue, text: t('gant.completedOverdue')},
    {state: State.NotStarted, dateState: StateDate.Plan, text: t('gant.notStarted')},
  ]

  return (
    <Flex align={'center'} style={{width: '100%'}} justify={'center'}>
      <Flex className="state-blocks-container" gap={10}>
        {blocks.map((block, index) => (
          <Flex key={index} className="state-item" gap={10}>
            <div
              className="state-block"
              style={{
                backgroundColor: (block.state && colors[block.state].background) ? colors[block.state].background : '',
                color: (block.dateState && colors[block.dateState].color) ? colors[block.dateState].color : '',
              }}
            >{t('gant.text')}</div>
            <Flex>
              {block.text}
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}
